import { FAIcon } from "../../core/components/faIcon";
import { PanelbarStructure } from "../../core/components/isPanelbarDetails";
import { Helper } from "../../core/util/helper";
import React from "react"
export default class DataSourceDetails extends React.Component<any, any> {
    private placeHolder: JSX.Element;
    private panelbarElement;
    constructor(props) {
        super(props)
        this.placeHolder = this.getPlaceHolder();
    }

    private getPlaceHolder = () => {
        const style: React.CSSProperties = {
            height: "36px",
            display: "flex",
            alignItems: "center",
            paddingLeft: "14px",
            paddingRight: "14px",
            borderStyle: "dashed",
            borderWidth: "1px",
            borderColor: "#999"

        };
        return (
            <div className="k-panelbar" style={style}>
                <span style={{ display: "inline-block", paddingRight: "10px", color: "#999" }} >
                    <FAIcon name={"database"} />
                </span >
            </div>
        );
    }


    private onCollapse = (e) => {
        $(".k-state-selected", e.item).removeClass("k-state-selected k-state-focused");
    }

    componentDidMount() {
        $(this.panelbarElement).children().kendoPanelBar({ collapse: this.onCollapse }).data("kendoPanelBar");
        let el = $(".k-panelbar-expand");
        el.css("display", "none")
    }

    render() {
        return (
            <>
                <div ref={(e) => this.panelbarElement = e} className="fieldValue panelAsAccordionField" style={{ width: "100%", display: Helper.isNullOrEmpty(this.props.value) ? "none" : null }} >                
                    <PanelbarStructure keyPropValue={this.props.value} label={Helper.getValueOrDefault(this.props.value, "")} iconName="database" url={encodeURI(`EmailSender/EditDataSource?id=${this.props.entity.dataSourceId}`)} />
                </div>
                <div style={{ display: Helper.isNullOrEmpty(this.props.value) ? null: "none" }}>
                    {this.placeHolder}
                </div>
            </>
        );
    }
}